__turbopack_context__.v({
  "colourBlock": "PublicSearch-module-scss-module__9KdFfa__colourBlock",
  "credit": "PublicSearch-module-scss-module__9KdFfa__credit",
  "innerSkinTone": "PublicSearch-module-scss-module__9KdFfa__innerSkinTone",
  "lightbox": "PublicSearch-module-scss-module__9KdFfa__lightbox",
  "lightboxCopyright": "PublicSearch-module-scss-module__9KdFfa__lightboxCopyright",
  "lightboxFooter": "PublicSearch-module-scss-module__9KdFfa__lightboxFooter",
  "lightboxImageBoundingBox": "PublicSearch-module-scss-module__9KdFfa__lightboxImageBoundingBox",
  "nextLink": "PublicSearch-module-scss-module__9KdFfa__nextLink",
  "pagination": "PublicSearch-module-scss-module__9KdFfa__pagination",
  "paginationActive": "PublicSearch-module-scss-module__9KdFfa__paginationActive",
  "paginationBreak": "PublicSearch-module-scss-module__9KdFfa__paginationBreak",
  "paginationContainer": "PublicSearch-module-scss-module__9KdFfa__paginationContainer",
  "paginationDisabled": "PublicSearch-module-scss-module__9KdFfa__paginationDisabled",
  "paginationDisabledLink": "PublicSearch-module-scss-module__9KdFfa__paginationDisabledLink",
  "paginationNext": "PublicSearch-module-scss-module__9KdFfa__paginationNext",
  "paginationPrevious": "PublicSearch-module-scss-module__9KdFfa__paginationPrevious",
  "previousLink": "PublicSearch-module-scss-module__9KdFfa__previousLink",
  "skinTone": "PublicSearch-module-scss-module__9KdFfa__skinTone",
  "tile": "PublicSearch-module-scss-module__9KdFfa__tile",
});
